import styled from '@emotion/styled'
import PopupButton from 'shared/components/Calendly/components/PopupButton/PopupButton'
import { getPxAsRem } from 'shared/utils'

export const ScheduleList = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${getPxAsRem(10)};
    padding: ${getPxAsRem(10)};
`

export const ScheduleItem = styled.div`
    padding: ${getPxAsRem(8)};
`

export const CancelButton = styled(PopupButton)`
    background-color: transparent;
    color: #d32f2f;
    border: 1px solid #d32f2f;
    border-radius: 8px;
    padding: ${getPxAsRem(6, 12)};
    font-size: ${getPxAsRem(12)};
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    transition:
        background-color 0.3s ease,
        color 0.3s ease;

    &:hover {
        background-color: transparent;
        color: #b71c1c;
    }
`

export const RescheduleButton = styled(PopupButton)`
    background-color: transparent;
    color: #007bc7;
    border: 1px solid #007bc7;
    border-radius: 8px;
    padding: ${getPxAsRem(6, 12)};
    font-size: ${getPxAsRem(12)};
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    transition:
        background-color 0.3s ease,
        color 0.3s ease;

    &:hover {
        background-color: transparent;
        color: #007bc7;
    }
`
